/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-use-before-define */
/* eslint-disable import/no-cycle */
import React, { useState, SetStateAction } from 'react';
import * as Yup from 'yup';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import 'bootstrap/dist/css/bootstrap.css';
import ReactDOM from 'react-dom';
import { Field, FieldProps, Form, Formik, FormikErrors } from 'formik';
import { itemsprops } from './procedure.component';
import './proceduremodal.component.css';
import { usePADomainModel } from '../../context/ctxPriorAuthorizationDomain';
import Pharmacy from '../Pharmacy/pharmacy.component';
import FormRow from '../FormRow/formrow.component';

type formDataProps = {
  [key: string]: any,
  startDate: Date | null,
  unitType: selectDropProps,
  unitFrequency: string;
  modifier: string;
  modifier2: string;
  NDCCode: string;
  drugName: string;
  doseQty: number | null;
  doseQtyUnit: string;
  route: selectDropProps;
  frequency: selectDropProps
  adjustedDrugDosage : string | null
};

   type selectDropProps =
    {
      label: string,
      value: string
    };

interface ProcedureModalProps {
  onClose: () => void;
  item: itemsprops;
  formData: formDataProps;
  setProcedureItem: React.Dispatch<SetStateAction<itemsprops>>;
  index: number;
  serviceDetailIndex: number,
  admissionStartDate: string,
  serviceType: string
}

const ProcedureModal: React.FC<ProcedureModalProps> = ({ onClose, formData, item, setProcedureItem, index, serviceDetailIndex, admissionStartDate, serviceType }) => {
  const [isAddModifier, setShowModifierTextBox] = useState<boolean>(!!formData.modifier2);
  const [selectedDrugItem, setSelectedDrugItem] = useState<itemsprops | null>(null);
  const pharmacyStartDateWidth = serviceType.toLowerCase() === 'pharmacy' ? '180.65%' : '100%';
  const handleSubmit = (values: formDataProps) => {
    const updatedItem = {
      procedureStartDate: values.startDate != null ? values.startDate.toLocaleDateString() : '',
      unitType: values.unitType.value,
      unitFrequency: values.startDate != null ? values.unitFrequency : '',
      modifier: values.modifier,
      modifier2: values.modifier2,
      procedureCode: item.procedureCode,
      cptCode: item.cptCode,
      lob: item.lob,
      processedBy: item.processedBy,
      NDCCode: selectedDrugItem?.NDCCode || item.NDCCode,
      drugName: selectedDrugItem?.drugName || item.drugName,
      doseQty: selectedDrugItem?.doseQty || item.doseQty,
      doseQtyUnit: selectedDrugItem?.doseQtyUnit || item.doseQtyUnit,
      route: values.route.value,
      frequency: values.frequency.value,
      adjustedDrugDosage: values.adjustedDrugDosage,
    };
    setProcedureItem(updatedItem);
    updateProcedureValidationStatus(serviceDetailIndex.toString(), index.toString(), true);
    onClose();
  };
  const { updateProcedureValidationStatus } = usePADomainModel();

  const options = [
    {
      label: 'HCPCS Units',
      value: 'HCPC Units',
    },
    {
      label: 'Units',
      value: 'Units',
    },
    {
      label: 'Visit',
      value: 'Visit',
    },
    {
      label: 'Hours',
      value: 'Hours',
    },
    {
      label: 'Days',
      value: 'Days',
    },
    {
      label: 'Month',
      value: 'Month',
    },
  ];

  const handleSelectedDrugItem = (drugItem: itemsprops) => {
    setSelectedDrugItem(drugItem);
  };

  const editModifier = () => {
    setShowModifierTextBox(true);
  };

  const removeModifier = (setFieldValue: { (field: string, value: any): Promise<void | FormikErrors<formDataProps>>; (arg0: string, arg1: string): void; }) => {
    setShowModifierTextBox(false);
    setFieldValue('modifier2', '');
  };

  const ErrorMessage: React.FC<{ errors: FormikErrors<formDataProps>; fieldName: string }> = ({ errors, fieldName }) => {
    const errorMessage = errors[fieldName];
    const dataId = `${fieldName}-error`;
    return typeof errorMessage === 'string' ? <div className="errorMessage" data-testid={dataId}>{errorMessage}</div> : null;
  };

  const validationSchema = Yup.object().shape({
    unitType: Yup.object().shape({
      label: Yup.string().notOneOf([''], 'Please provide a unit type'),
      value: Yup.string().notOneOf([''], 'Please provide a unit type'),
    }).required('Please provide a unit type'),
    unitFrequency: Yup.string()
      .matches(/^[1-9][0-9]*$/, { message: 'Must be digits and greater than 0', excludeEmptyString: true })
      .required('Please provide requested number of units'),
    startDate: Yup.date()
      .required('Please provide a start date'),
    modifier: Yup.string()
      .matches(/^[a-zA-Z0-9]{2,}$/, { message: 'Only 2 letters/numbers are allowed', excludeEmptyString: true })
      .max(2, 'Must be only 2 characters long'),
    modifier2: Yup.string()
      .matches(/^[a-zA-Z0-9]{2,}$/, { message: 'Only 2 letters/numbers are allowed', excludeEmptyString: true })
      .max(2, 'Must be only 2 characters long'),
    route: Yup.object().shape({
      label: Yup.string()
        .when([], {
          is: () => serviceType.toLowerCase() === 'pharmacy',
          then: () => Yup.string().notOneOf(['', 'Other'], 'Please provide a valid route'),
        }),
      value: Yup.string()
        .when([], {
          is: () => serviceType.toLowerCase() === 'pharmacy',
          then: () => Yup.string().notOneOf(['', 'Other'], 'Please provide a valid route'),
        }),
    }).required('Please provide a valid route'),
    frequency: Yup.object().shape({
      label: Yup.string()
        .when([], {
          is: () => serviceType.toLowerCase() === 'pharmacy',
          then: () => Yup.string().notOneOf([''], 'Please provide a Frequency'),
        }),
      value: Yup.string()
        .when([], {
          is: () => serviceType.toLowerCase() === 'pharmacy',
          then: () => Yup.string().notOneOf([''], 'Please provide a Frequency'),
        }),
    }).required('Please provide a Frequency'),
  });
  const validate = (values: any) => {
    const errors: any = {};
    if (!values.unitType) {
      const errorMsg = 'Please provide a unit type';
      errors.unitType = errorMsg;
    }
    if (values.unitType.value === '') {
      const errorMsg = 'Please provide a unit type';
      errors.unitType = errorMsg;
    }
    if (!values.unitFrequency) {
      const errorMsg = 'Please provide requested number of units';
      errors.unitFrequency = errorMsg;
    } if (!values.startDate) {
      const errorMsg = 'Please provide a procedure start date';
      errors.startDate = errorMsg;
    } if (serviceType.toLowerCase() === 'pharmacy' && values.route.value === '') {
      const errorMsg = 'Please provide a valid route';
      errors.route = errorMsg;
    }
    if (values.route && values.route.value === 'Other') {
      const errorMsg = 'Unable to proceed with this request. Please contact your Health Plan.';
      errors.route = errorMsg;
    }
    if (serviceType.toLowerCase() === 'pharmacy' && values.frequency.value === '') {
      const errorMsg = 'Please provide Frequency';
      errors.frequency = errorMsg;
    }
    return errors;
  };

  return ReactDOM.createPortal(
    <div className="modal fade show proceduremodal" data-testId="procedurecomponentmodal" aria-modal="true" tabIndex={-1} role="dialog">
      <div className={serviceType.toLowerCase() === 'pharmacy' ? 'modal-dialog modal-lg' : 'modal-dialog'} role="document">
        <div className="modal-content">
          <div className="modal-header shadow-sm">
            <h5 className="modal-title">Edit Procedure Details </h5>
            <button
              type="button"
              className="btn-close btn-sm btnClose"
              aria-label="Close"
              onClick={() => onClose()}
            />
          </div>
          <div className="modal-body">
            <Formik initialValues={formData} onSubmit={handleSubmit} validationSchema={validationSchema} validate={validate} validateOnMount>
              {({ setFieldValue, errors }) => (
                <Form>
                  <div className="form-group">
                    <FormRow>
                      <div className="form-group">
                        <label className="fw-bold mb-0" htmlFor="StartDate">Start Date</label>
                        <div>
                          <Field name="startDate" type="text" className="form-control">
                            {({ field, form }: FieldProps) => (
                              <DatePicker
                                id="startDate"
                                name="startDate"
                                selected={field.value}
                                className={`form-control inputField ${errors.startDate ? 'inputFieldError' : ''}`}
                                onChange={(date) => form.setFieldValue('startDate', date)}
                                onBlur={() => form.setFieldTouched('startDate', true)}
                                dateFormat="MM/dd/yyyy"
                                placeholderText="mm/dd/yyyy"
                                customInput={<input className="startdate" style={{ width: pharmacyStartDateWidth }} />}
                                minDate={new Date(admissionStartDate)}
                              />
                            )}
                          </Field>
                          <ErrorMessage errors={errors} fieldName="startDate" />
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="fw-bold mb-0" htmlFor="unitType">Unit Type</label>
                        <Select
                          id="unitType"
                          name="unitType.value"
                          options={options}
                          defaultValue={formData.unitType}
                          isSearchable={false}
                          onChange={(option) => setFieldValue('unitType', option)}
                          className={errors.unitType ? 'selectUnitTypeError' : 'selectUnitType'}
                          isDisabled={serviceType.toLowerCase() === 'pharmacy'}
                        />
                        <ErrorMessage errors={errors} fieldName="unitType" />
                      </div>
                    </FormRow>
                    <div>
                      <label className="fw-bold mb-0 mt-3" htmlFor="service-unitFrequency-2">Requested Number of Units</label>
                      <Field
                        type="text"
                        id="service-unitFrequency-2"
                        name="unitFrequency"
                        required="true"
                        render={({ field }: FieldProps) => (
                          <input
                            {...field}
                            type="text"
                            className={`form-control inputField ${errors.unitFrequency ? 'inputFieldError' : ''}`}
                            data-testid="service-unitFrequency-2"
                          />
                        )}
                      />
                      <ErrorMessage errors={errors} fieldName="unitFrequency" />
                    </div>
                    <div className="form-group  modifier">
                      <label className="fw-bold mb-0" htmlFor="modifier-1">Modifier (optional)</label>
                      <Field
                        type="text"
                        id="modifier-1"
                        name="modifier"
                        required="false"
                        render={({ field }: FieldProps) => (
                          <input {...field} type="text" className="form-control mb-3" data-testid="modifier-1" />
                        )}
                      />
                      <ErrorMessage errors={errors} fieldName="modifier" />
                      <div className="justify-content-start mt-1" id="edit-modifier-button" style={{ display: isAddModifier ? 'none' : 'block' }}>
                        <button type="button" className="btnstyle" data-testid="addmodifier" onClick={() => editModifier()}>Add Modifier</button>
                      </div>
                      <div className="mt-3 mb-2" id="new-modifier" style={{ display: isAddModifier ? 'block' : 'none' }}>
                        <label className="fw-bold mb-0" htmlFor="sp-modifier-2">Modifier 2 (optional)</label>
                        <div className="input-group">
                          <Field
                            type="text"
                            id="modifier-2"
                            className="form-control"
                            name="modifier2"
                            required="true"
                            render={({ field }: FieldProps) => (
                              <input {...field} type="text" className="form-control mb-3" data-testid="modifier-2" />
                            )}
                          />
                          <button className="btn-outline-primary modifier2button" data-testid="removemodifier" type="button" onClick={() => removeModifier(setFieldValue)}>
                            <i className="fas fa-times p-1 fafasimage" />
                          </button>
                        </div>
                        <ErrorMessage errors={errors} fieldName="modifier2" />
                      </div>
                    </div>
                    {/* // Adding Pharmacy Info  */}
                    {serviceType.toLowerCase() === 'pharmacy' ? (
                      <>
                        <Pharmacy formData={formData} errors={errors} setFieldValue={setFieldValue} ErrorMessage={ErrorMessage} handleSelectedDrugItem={handleSelectedDrugItem} />
                        <div className="mt-5">
                          <button className="btn btn btn-primary rounded-pill mr-2 px-4" disabled={Object.keys(errors).length > 0} type="submit" data-testid="save">
                            Save
                          </button>
                        </div>
                      </>
                    )
                      : (
                        <div className="mt-5">
                          <button className="btn btn btn-primary rounded-pill mr-2 px-4" disabled={Object.keys(errors).length > 0} type="submit" data-testid="save">
                            Save
                          </button>
                        </div>
                      )}
                  </div>

                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default ProcedureModal;
